import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Input, InputGroup } from 'reactstrap';
import debounce from 'lodash.debounce';
import './SimpleSearchBox.css';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../Telemetry/Mixpanel/Features/analyticsTracker';
import { SEARCH, VALUE_ADD } from '../../Telemetry/Mixpanel/Constants/mixpanelConstants';

export class SimpleSearchBox extends Component {
  static propTypes = {
    onSearchInputChange: PropTypes.func,
    placeHolder: PropTypes.string.isRequired,
    searchString: PropTypes.string,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string,
      searchType: PropTypes.string
    })
  };
  constructor(props) {
    super(props);
    this.state = {
      searchParam: ''
    };
    this.changed = debounce(val => {
      this.props.onSearchInputChange(val);
      if (val !== null) {
        if (this.props.mixpanelData.searchType) {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, this.props.mixpanelData.searchType);
        } else {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, SEARCH);
        }
        if (this.props.mixpanelData.reportType) {
          trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, SEARCH);
        }
      }
    }, 250);
  }

  onSearchChange = event => {
    if (event.target !== null) {
      const val = event.target.value;
      this.setState({ searchParam: val }, () => {
        this.changed(val);
      });
    }
  };

  componentDidMount() {
    if (this.props.searchString !== this.state.searchParam) {
      this.setState({ searchParam: this.props.searchString });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchString !== prevProps.searchString) {
      this.setState({ searchParam: this.props.searchString });
    }
  }

  render() {
    return (
      <div className="searchBoxContainer">
        <div className="searchInputGroup">
          <InputGroup className="inputGroup">
            <i className="togo-icon togo-icon-search togo-icon-1x searchIcon" />
            <Input
              value={this.state.searchParam}
              type="search"
              placeholder={this.props.placeHolder}
              className="searchInput"
              onChange={this.onSearchChange}
            />
          </InputGroup>
        </div>
      </div>
    );
  }
}

export default SimpleSearchBox;



// WEBPACK FOOTER //
// ./src/Components/SearchBox/SimpleSearchBox.js